


export const erpSyncType = {
    cash : 1,
    receipt:2,
    creditCardReceipt: 3,
    fastPayment: 4,
    virement:5
}